import React from "react";
import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import {
  FiLock,
  FiLogOut,
} from "react-icons/fi";

export default function Header() {
  // =====================================================
  // ROUTER
  // =====================================================
  const location = useLocation();
  const navigate = useNavigate();

  // =====================================================
  // GET CURRENT PAGE NAME
  // =====================================================
  const getPageName = () => {
    const path = location.pathname;

    const pageMap = {
      "/dashboard": "Dashboard",
      "/user-management": "User Management",
      "/rent-durations": "Rental Slab",
      "/season-name": "Season Name",
      "/season-duration": "Season Duration",
      "/manage-brand": "Brand Name",
      "/manage-transmission": "Transmission",
      "/manage-engcapacity": "Engine Capacity",
      "/cargroup": "Car Group",
      "/caritems": "Car Items",
      "/manage-cars": "Car Model Details",
      "/stop-sale": "Stop Sale",
      "/manage-regular-clients": "Regular Client Details",
      "/car-price": "Price Details",
      "/special-discount": "Special Discount",
      "/manage-special-hour": "Special Hour Charge",
      "/coupon-code": "Manage Coupon Code",
      "/manage-insurance": "Manage Extra Insurance",
      "/insurance-detail": "Paid Insurance Details",
      "/manage-contacts": "Manage Contacts",
      "/manage-location": "Manage Location",
      "/generate-manage-bookings-Excal": "Generate Bookings Excal",
      "/manage-banners": "Manage Banners",
      "/manage-seo": "Manage SEO",     
      "/manage-faqs": "Manage FAQ",
      "/manage-optionalextra": "Optional Extra Items",
      "/optional-extra-detail": "Optional Extra Details",
      "/manage-bookings": "Manage Online Bookings",
      "/del-online": "Deleted Online Booking",
      "/manage-modifyacancel-requests": " Manage Modify / Cancel Requests",
      "/manage-multiple-booking-details" : "Manage Multiple Booking Details",
      "/manage-language" : "Manage Languages",
      "/manage-infoinenglish" : "Manage ML Information in English",
      "/manage-static-infos" : "Static Information",
      "/manage-dynamic-infos" : "Dynamic Information",
      "/manage-messages-infos" : "Messages",
      
      // 1416 - End




      "/cab-owner-details": "Cab Owner Details",
      "/driver-details": "Driver Details",
      "/cab-details": "Individual Fleet Details",
      "/leasing-cars": "Leasing Car Details",
      "/page-content": "Leasing Page Content",
      "/manage-leasinginq": "Leasing Inquiries",
      "/manage-city": "City Name",
      "/manage-delaycharge": "Manage Delay Charge",
      "/manage-nightdelivery": "Night Delivery",
      "/manage-pagemaster": "Page Master",
      "/manage-setting": "Parameters",
      "/manage-section": "Default Section",
      "/manage-booking-engine": "Booking Engine",
      "/manage-transferbooking": "Manage Transfer Bookings",
      "/manage-contracts": "Manage Rent Agreement",
      "/manag-inquiry": "Manage Inquiry",
      "/manage-request": "Manage Request",
      "/manage-attraction": "Manage Attraction",
      "/manage-testimonial": "Manage Testimonial",
      "/manage-gallery": "Manage Gallery",
      "/manage-content": "Manage Content",
      "/change-password": "Change Password",
    };

    return pageMap[path] || "Dashboard";
  };

  const pageName = getPageName();

  // =====================================================
  // GET USER DETAILS
  // =====================================================
  const user =
    JSON.parse(
      localStorage.getItem("user")
    ) || {};

  const userName =
    user?.user_name || "ADMIN";

  const firstLetter =
    userName?.charAt(0)?.toUpperCase() ||
    "A";

  // =====================================================
  // CURRENT DATE
  // =====================================================
  const today = new Date();

  const formattedDate =
    today.toLocaleDateString("en-GB", {
      weekday: "long",
      day: "2-digit",
      month: "long",
    });

  // =====================================================
  // CHANGE PASSWORD
  // =====================================================
  const handleChangePassword = () => {
    navigate("/change-password");
  };

  // =====================================================
  // LOGOUT
  // =====================================================
  const handleLogout = () => {
    // Remove login information
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    // Go to login page
    navigate("/login");
  };

  // =====================================================
  // JSX
  // =====================================================
  return (
    <header className="topHeader">

      {/* =================================================
          LEFT SIDE
      ================================================= */}
      <div className="headerLeft">

        {/* ADMIN CONSOLE */}
        <span className="brandTitle">
          ADMIN CONSOLE
        </span>

        {/* SEPARATOR */}
        <span className="headerSlash">
          /
        </span>

        {/* CURRENT PAGE */}
        <span className="currentPage">
          {pageName}
        </span>

      </div>

      {/* =================================================
          RIGHT SIDE
      ================================================= */}
      <div className="headerRight">

        {/* CURRENT DATE */}
        <span className="headerDate">
          {formattedDate}
        </span>

        {/* =================================================
            ADMIN PROFILE
        ================================================= */}
        <div className="adminProfile">

          {/* AVATAR */}
          <div className="adminAvatar">
            {firstLetter}
          </div>

          {/* USER NAME */}
          <span className="adminName">
            {userName}
          </span>

          {/* =================================================
              PROFILE SUB MENU
          ================================================= */}
          <div className="adminSubMenu">

            {/* CHANGE PASSWORD */}
            <button
              type="button"
              className="submenu-item"
              onClick={
                handleChangePassword
              }
            >
              <FiLock size={14} />

              <span>
                Change Password
              </span>
            </button>

            {/* LOGOUT */}
            <button
              type="button"
              className="submenu-item logout"
              onClick={
                handleLogout
              }
            >
              <FiLogOut size={14} />

              <span>
                Logout
              </span>
            </button>

          </div>

        </div>

      </div>

    </header>
  );
}

